import React, { useCallback, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import Field from 'components/Field';
import SectionHeading from 'components/SectionHeading';
import { LibrarySelect } from 'features/classCreation';
import styles from './SelectLibraryPage.module.scss';

export default function SelectLibraryPage() {
  const [selectedLibrary, setSelectedLibrary] = useState();
  const navigate = useNavigate();

  const handleLibraryChange = useCallback(
    (option) => {
      setSelectedLibrary(option);
      navigate(String(option.value));
    },
    [navigate]
  );

  return (
    <>
      <SectionHeading
        title="EDIT LIBRARIES"
        subtitle="Edit libraries using the following flow."
      />
      <div className={styles.pageContainer}>
        <Field label="Library Details">
          <LibrarySelect
            onChange={handleLibraryChange}
            value={selectedLibrary}
          />
        </Field>
        <Outlet />
      </div>
    </>
  );
}
